export enum KPIsWidgetEnum {
  TB,
  OBDNotUsed,
  Cancellations,
  DeviationJobs,
  VehicleFaults,
  ETAAccuracy,
  AssignmentsPlanning,
  UniqueAssignees,
  CasesBySupplier,
  DeliveryCondition,
  AverageDrivingDistance,
  // Ledningsrapporten till RM
  DeliveredCars,
  InternalDeliveryTransport,
  CancellationReasons,
  CustomerSatisfaction,
  ResourceUtilization,
  TruckCoverage,
  TransportLeadTime,
  // Sist så att de sparade layouternas nummer inte flyttas.
  BookedToChanges,
  // Operativa nyckeltal (Alex, okt 2026)
  HotelNights,
  FieldTestersWithoutJobs,
  DeclinedJobs,
  FieldTesterTenure,
  CentralStationOvernights,
  DeniedAssignmentRequests,
  ReturnToLogistics,
  TB1ByCaseTypeAndCounty,
  SingleLegJobs,
  WorkedTimePerFieldTesterDay,
}

export const UPDATE_INTERVAL = 15000; // 15sek

export const DefaultKPIsWidgets = [
  {
    identifier: KPIsWidgetEnum.TB,
    shortTitle: 'TB',
    longTitle: 'Täckningsbidrag (TB)',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.OBDNotUsed,
    shortTitle: 'OBD',
    longTitle: 'Ej använt OBD',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.Cancellations,
    shortTitle: 'Avbok',
    longTitle: 'Avbok/ombok per säljare',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeviationJobs,
    shortTitle: 'Avvik jobb',
    longTitle: 'Avvikande jobb',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.VehicleFaults,
    shortTitle: 'Fel bil',
    longTitle: 'Fel på bil',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.ETAAccuracy,
    shortTitle: 'ETA',
    longTitle: 'ETA-precision',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.AssignmentsPlanning,
    shortTitle: 'Planering',
    longTitle: 'Planerade uppdrag per admin',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.UniqueAssignees,
    shortTitle: 'Planerade FT',
    longTitle: 'Fälttestare planerade per admin',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.CasesBySupplier,
    shortTitle: 'Leverantörer',
    longTitle: 'Ärenden per leverantör',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeliveryCondition,
    shortTitle: 'Leveransskick',
    longTitle: 'Leveransskick per säljare',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.AverageDrivingDistance,
    shortTitle: 'Snittsträcka',
    longTitle: 'Snittsträcka vs faktiskt utfall',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.TB1ByCaseTypeAndCounty,
    shortTitle: 'TB1 per län',
    longTitle: 'TB1 per ärendetyp och län',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.ReturnToLogistics,
    shortTitle: 'Till Strängnäs',
    longTitle: 'Inköp/inbyte: från kund till Logistik Strängnäs (utan lastbil)',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.SingleLegJobs,
    shortTitle: 'Enbenskörningar',
    longTitle: 'Enbenskörningar inom och utom FT:s län',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.WorkedTimePerFieldTesterDay,
    shortTitle: 'Tid per FT-dag',
    longTitle: 'Arbetad tid per FT-dag och hemlän',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.HotelNights,
    shortTitle: 'Hotellnätter',
    longTitle: 'Hotellnätter per inköp/hemleverans och län',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.FieldTestersWithoutJobs,
    shortTitle: 'FT utan jobb',
    longTitle: 'Tillgängliga fälttestare utan jobb',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeclinedJobs,
    shortTitle: 'Nekade jobb',
    longTitle: 'Nekade jobb per län',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.FieldTesterTenure,
    shortTitle: 'Anställningstid',
    longTitle: 'Fälttestarnas anställningstid per hemlän',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.CentralStationOvernights,
    shortTitle: 'Centralstationer',
    longTitle: 'Bilar som avslutat dagen på en centralstation',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeniedAssignmentRequests,
    shortTitle: 'Avslag annons',
    longTitle: 'Avslagna annonsförfrågningar per anledning',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeliveredCars,
    shortTitle: 'Levererade',
    longTitle: 'Levererade bilar per ärendetyp',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.InternalDeliveryTransport,
    shortTitle: 'Annons transport',
    longTitle: 'Annons: lastbil kontra fälttestare',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.CancellationReasons,
    shortTitle: 'Avboksorsak',
    longTitle: 'Avbokningar per orsak',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.BookedToChanges,
    shortTitle: 'Ombokningar',
    longTitle: 'Ändrade bokningstider',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.CustomerSatisfaction,
    shortTitle: 'Kundnöjdhet',
    longTitle: 'Kundnöjdhet per ärendetyp',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.ResourceUtilization,
    shortTitle: 'Resursutnyttjande',
    longTitle: 'Resursutnyttjande mot arbetstidstak',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.TruckCoverage,
    shortTitle: 'Fyllnadsgrad',
    longTitle: 'Fyllnadsgrad lastbil in och ut',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.TransportLeadTime,
    shortTitle: 'På transport',
    longTitle: 'Snitt för bilar på transport',
    active: true,
  },
];

export const TrafikLedarAdminWidgets = [
  {
    identifier: KPIsWidgetEnum.AssignmentsPlanning,
    shortTitle: 'Planering',
    longTitle: 'Planerade uppdrag per admin',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.UniqueAssignees,
    shortTitle: 'Planerade FT',
    longTitle: 'Fälttestare planerade per admin',
    active: true,
  },
];

/**
 * RM-nyckeltalens ursprungliga widgetar. Rollen RiddermarkLedning räcker för de här — de har
 * inget med ledningsrapporten att göra och ska synas även utan feature-flaggan.
 */
export const RiddermarkBaseWidgets = [
  {
    identifier: KPIsWidgetEnum.Cancellations,
    shortTitle: 'Avbok',
    longTitle: 'Avbok/ombok per säljare',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeviationJobs,
    shortTitle: 'Avvik jobb',
    longTitle: 'Avvikande jobb',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.VehicleFaults,
    shortTitle: 'Fel bil',
    longTitle: 'Fel på bil',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.DeliveryCondition,
    shortTitle: 'Leveransskick',
    longTitle: 'Leveransskick per säljare',
    active: true,
  },
];

/**
 * Ledningsrapportens widgetar.
 *
 * Ligger bakom GlobalSettingEnum.UsersWithAccessToRiddermarkReporting (99) och hålls därför i
 * en egen lista. Listan som skickas till DashboardControlsProvider är också den widgetväljaren
 * visar, så utan tillgång ska de inte gå att VÄLJA — inte bara rendera tomma. Deras endpoints
 * är dessutom spärrade på servern, så en sparad markering från tiden före flaggan ger 403.
 */
export const RiddermarkManagementWidgets = [
  {
    identifier: KPIsWidgetEnum.DeliveredCars,
    shortTitle: 'Levererade',
    longTitle: 'Levererade bilar per ärendetyp',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.InternalDeliveryTransport,
    shortTitle: 'Annons transport',
    longTitle: 'Annons: lastbil kontra fälttestare',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.CancellationReasons,
    shortTitle: 'Avboksorsak',
    longTitle: 'Avbokningar per orsak',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.BookedToChanges,
    shortTitle: 'Ombokningar',
    longTitle: 'Ändrade bokningstider',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.CustomerSatisfaction,
    shortTitle: 'Kundnöjdhet',
    longTitle: 'Kundnöjdhet per ärendetyp',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.ResourceUtilization,
    shortTitle: 'Resursutnyttjande',
    longTitle: 'Resursutnyttjande mot arbetstidstak',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.TruckCoverage,
    shortTitle: 'Fyllnadsgrad',
    longTitle: 'Fyllnadsgrad lastbil in och ut',
    active: true,
  },
  {
    identifier: KPIsWidgetEnum.TransportLeadTime,
    shortTitle: 'På transport',
    longTitle: 'Snitt för bilar på transport',
    active: true,
  },
];

export const LongTitles = DefaultKPIsWidgets.reduce(
  (titles, widget) => ({
    ...titles,
    [widget.identifier]: widget.longTitle,
  }),
  {} as Record<KPIsWidgetEnum, string>
);
